import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailVerificationCodeComponent } from './email-verification-code.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmailVerificationRoutingModule } from './email-verification-routing.module';

@NgModule({
  declarations: [EmailVerificationCodeComponent],
  imports: [CommonModule, SharedModule, EmailVerificationRoutingModule]
})
export class EmailVerificationCodeModule {}
